import { useUserTzContext } from "src/components/features/medium/AssetsFilter/components/TimeWindow/hooks/useUserTzContext";
import { getCalendarPresetLabel } from "src/components/features/medium/AssetsFilter/components/TimeWindow/TimeWindow.calendarPresets";
import { TIME_WINDOW_DEFAULT } from "src/components/features/medium/AssetsFilter/components/TimeWindow/TimeWindow.constants";
import {
  getTimeWindowDurationText,
  getTimeWindowSelectionLabel,
  parseTimeWindowSelection,
} from "src/components/features/medium/AssetsFilter/components/TimeWindow/TimeWindow.selection";
import { useSearchStorage } from "src/storage/useSearchStorage";

/**
 * Selection as a bare phrase, for use inside sentences ("in the past 7 days") -
 * hence no "Last " prefix on durations, unlike the filter's own field label.
 */
export const useReadableTimeWindow = () => {
  const { timeWindow = TIME_WINDOW_DEFAULT } = useSearchStorage();
  const tzCtx = useUserTzContext();

  // Named tokens and legacy frozen `~~` ranges both resolve to a preset label.
  const calendarLabel = getCalendarPresetLabel(timeWindow, tzCtx);
  if (calendarLabel) {
    return calendarLabel;
  }

  const durationText = getTimeWindowDurationText(timeWindow);
  if (durationText) {
    return durationText;
  }

  if (parseTimeWindowSelection(timeWindow)?.kind === "range") {
    return "Custom time window";
  }

  return getTimeWindowSelectionLabel(timeWindow);
};
